export enum StrongBoxComplianceType  {
    NotActive = 0,
    AddressConfirmation = 1,
    AddressMissing = 5,
    AddressMissingInformation = 10,
    PhysicalInventory = 2
}